<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from "vue";

const POPUP_IMAGE = "/images/popup.jpeg";

const isOpen = ref(true);
let savedScrollY = 0;

const lockScroll = () => {
  savedScrollY = window.scrollY;
  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.top = `-${savedScrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
};

const unlockScroll = () => {
  document.documentElement.style.overflow = "";
  document.body.style.overflow = "";
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";
  window.scrollTo(0, savedScrollY);
};

const close = () => {
  isOpen.value = false;
};

const onKeydown = (e) => {
  if (e.key === "Escape") close();
};

watch(
  isOpen,
  (open) => {
    if (open) lockScroll();
    else unlockScroll();
  },
  { immediate: true },
);

onMounted(() => {
  document.addEventListener("keydown", onKeydown);
});

onBeforeUnmount(() => {
  document.removeEventListener("keydown", onKeydown);
  unlockScroll();
});
</script>

<template>
  <Teleport to="body">
    <Transition name="home-popup">
      <div
        v-if="isOpen"
        class="fixed inset-0 z-[10000] flex cursor-pointer items-center justify-center overflow-hidden overscroll-none bg-on-background/75 p-4 backdrop-blur-sm sm:p-6"
        role="dialog"
        aria-modal="true"
        aria-label="Announcement"
        @click="close"
        @touchmove.prevent
        @wheel.prevent
      >
        <button
          type="button"
          class="inline-flex btn-header-search absolute right-4 top-4 z-20 bg-white sm:right-6 sm:top-6"
          aria-label="Close announcement"
          @click.stop="close"
        >
          <span class="material-symbols-outlined text-[22px]">close</span>
        </button>

        <img
          :src="POPUP_IMAGE"
          alt="Brand Integrated — We untangle brand complexity to ignite growth"
          class="max-h-[min(90vh,900px)] w-auto max-w-full object-contain shadow-2xl"
          @click="close"
        />
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.home-popup-enter-active,
.home-popup-leave-active {
  transition: opacity 0.25s ease;
}

.home-popup-enter-from,
.home-popup-leave-to {
  opacity: 0;
}
</style>
